module.exports = __webpack_public_path__ + "static/aPlaceForMom-4a0c99076805a322fa0d15816d980a15.svg";